<template>
  <validation-observer ref="simpleRules">
    <!-- Section: Informasi Toko -->
    <div class="mb-3">
      <h3>
        Informasi Toko
      </h3>
      <p class="text-muted">Detail dan informasi toko brand.</p>
    </div>

    <!-- Image -->
    <b-form-group
      label="Foto Brand"
      label-for="v-image"
    >
      <validation-provider
        #default="{ errors }"
        name="Icon"
        rules="required"
      >
        <form-image
          id="v-image"
          v-model="form.image"
          label="Pilih Foto"
          :state="errors.length > 0 ? false : null"
          @finish="setPhotoFile"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Nama -->
    <b-form-group
      label="Nama"
      label-for="v-name"
    >
      <validation-provider
        #default="{ errors }"
        name="Nama"
        rules="required"
      >
        <b-form-input
          id="v-name"
          v-model="form.name"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Email -->
    <b-form-group
      label="Email"
      label-for="v-email"
    >
      <validation-provider
        #default="{ errors }"
        name="Email"
        rules="required|email"
      >
        <b-form-input
          id="v-email"
          v-model="form.email"
          :state="errors.length > 0 ? false : null"
          :disabled="isProfile"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Password -->
    <b-form-group
      v-if="!isEdit && !isProfile"
      label="Password"
      label-for="v-password"
    >
      <validation-provider
        #default="{ errors }"
        name="Password"
        rules="required"
      >
        <b-input-group
          class="input-group-merge"
          :class="errors.length > 0 ? 'is-invalid':null"
        >
          <b-form-input
            id="v-password"
            v-model="form.password"
            :state="errors.length > 0 ? false:null"
            class="form-control-merge"
            :type="passwordFieldType"
            name="password"
            placeholder="············"
          />
          <b-input-group-append is-text>
            <feather-icon
              class="cursor-pointer"
              :icon="passwordToggleIcon"
              @click="togglePasswordVisibility"
            />
          </b-input-group-append>
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Urutan -->
    <b-form-group v-if="!isProfile">
      <label
        for="v-order"
      >
        Urutan <span v-b-tooltip.hover.top="toolTipUrutan"><feather-icon
          icon="AlertCircleIcon"
        /></span>
      </label>
      <validation-provider
        #default="{ errors }"
        name="Urutan"
      >
        <b-form-input
          id="v-order"
          v-model="form.order"
          :state="errors.length > 0 ? false : null"
          type="number"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- NO -->
    <b-form-group
      label="No. HP"
      label-for="v-phone"
    >
      <validation-provider
        #default="{ errors }"
        name="No. HP"
        rules="required"
      >
        <b-form-input
          id="v-phone"
          v-model="form.phone"
          :state="errors.length > 0 ? false : null"
          type="number"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Deskripsi -->
    <b-form-group
      label="Deskripsi Toko"
      label-for="v-description"
    >
      <validation-provider
        #default="{ errors }"
        name="Deskripsi Toko"
        rules="required"
      >
        <b-form-textarea
          id="v-description"
          v-model="form.description"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Section: Pengaturan Toko -->
    <div class="mb-3">
      <hr class="mb-2">
      <h3>
        Pengaturan Toko
      </h3>
      <p class="text-muted">Atur visibilitas, status operasional, dan fitur toko.</p>
    </div>

    <!-- Tampilkan Toko -->
    <b-form-group
      label="Tampilkan Toko"
      label-for="v-is_active"
    >
      <validation-provider
        #default="{ errors }"
        name="Tampilkan Toko"
        rules="required"
      >
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="form.is_active"
            class="mt-0"
            name="is_active"
            value="1"
          >
            Tampilkan
          </b-form-radio>
          <b-form-radio
            v-model="form.is_active"
            class="mt-0"
            name="is_active"
            value="0"
          >
            Sembunyikan
          </b-form-radio>
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Status -->
    <b-form-group
      label="Status"
      label-for="v-is_open"
    >
      <validation-provider
        #default="{ errors }"
        name="Status"
        rules="required"
      >
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="form.is_open"
            class="mt-0"
            name="is_open"
            :value="1"
          >
            Buka
          </b-form-radio>
          <b-form-radio
            v-model="form.is_open"
            class="mt-0"
            name="is_open"
            :value="0"
          >
            Tutup
          </b-form-radio>
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Pembungkus-->
    <b-form-group>
      <label
        for="v-is_gift_wrap_enabled"
      >
        Menyediakan Bungkus Kado Gratis <span v-b-tooltip.hover.top="'Pelanggan dapat menambahkan bungkus kado gratis pada saat checkout.'"><feather-icon
          icon="AlertCircleIcon"
        /></span>
      </label>
      <validation-provider
        #default="{ errors }"
        name="Menyediakan Bungkus Kado Gratis"
        rules="required"
      >
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="form.is_gift_wrap_enabled"
            class="mt-0"
            name="is_gift_wrap_enabled"
            :value="1"
          >
            Ya
          </b-form-radio>
          <b-form-radio
            v-model="form.is_gift_wrap_enabled"
            class="mt-0"
            name="is_gift_wrap_enabled"
            :value="0"
          >
            Tidak
          </b-form-radio>
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- is not open -->
    <div
      v-if="form.is_open === 0"
      class="mt-3"
    >
      <!-- tutup sampai -->
      <b-form-group
        label="Tutup Sampai Tanggal"
        label-for="v-close-ended-at"
      >
        <validation-provider
          #default="{ errors }"
          name="Tutup Sampai Tanggal"
          rules="required"
        >
          <b-form-datepicker
            id="v-close-ended-at"
            v-model="form.close_ended_at"
            class="mb-1"
            @input="initStartClose"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- alasan tutup -->
      <b-form-group
        label="Alasan Tutup"
        label-for="v-close-desc"
      >
        <validation-provider
          #default="{ errors }"
          name="Alasan Tutup"
        >
          <b-form-textarea
            id="v-close-desc"
            v-model="form.close_desc"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </div>

    <!-- <div
      v-if="isEdit"
      class="mt-4"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="modalChangePasswordShow = !modalChangePasswordShow"
      >
        Edit Password
      </b-button>
    </div> -->

    <!-- edit password modal -->
    <b-modal
      v-if="!isEdit"
      v-model="modalChangePasswordShow"
      title="Edit Password Brand"
      ok-title="Accept"
      ok-only
    >
      <div>
        <b-form-group
          v-if="!isEdit"
          label="Password"
          label-for="v-password"
        >
          <validation-provider
            #default="{ errors }"
            name="Password Baru"
            rules="required"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid':null"
            >
              <b-form-input
                id="v-password-new"
                v-model="password"
                :state="errors.length > 0 ? false:null"
                class="form-control-merge"
                :type="passwordFieldType"
                name="Password Baru"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  VBTooltip,
  BFormTextarea,
  BFormRadio,
  BFormDatepicker,
  // BButton,
  BModal,
} from 'bootstrap-vue'

import FormImage from '@/layouts/components/custom/FormImage.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// Vee Validate
import { required } from '@validations'

import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'BrandProfileForm',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BFormTextarea,
    BFormRadio,
    BFormDatepicker,
    // BButton,
    BModal,
    // form
    FormImage,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [togglePasswordVisibility],
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toolTipUrutan: 'Dapat digunakan untuk promosi',
      required,
      passwordFieldType: 'password',
      options: {
        prefix: {
          prefix: '+62',
          blocks: [3, 3, 3, 4],
          uppercase: true,
        },
      },
      modalChangePasswordShow: false,
      password: '',
      // isNotOpen: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  // watch: {
  //   form() {
  //     if (this.form.is_open === false || this.form.is_open === '0' || this.form.is_open === 0) {
  //       this.isNotOpen = true
  //     } else {
  //       this.isNotOpen = false
  //     }
  //   },
  // },
  methods: {
    setPhotoFile(file) {
      if (file) {
        this.form.imageFile = file
      }
    },
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
    initStartClose() {
      const today = new Date()
      const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`

      this.form.close_started_at = date
    },
  },
}
</script>
